import { BLURB, DOMAIN, TITLE } from "shared/SharedConstants";
import type { Metadata, MetadataImage } from "src/lib/Metadata";

export const SITE_URL = new URL(`https://${DOMAIN}`);
export const LANDING_TITLE = BLURB;
export const SITE_DESCRIPTION =
  "Moderate the images, text, audio, video, documents and websites your users upload, then deliver allowed content from a built-in CDN with signed URLs.";
export const SOCIAL_IMAGE_ALT = `${TITLE} — ${BLURB}`;

/**
 * The Open Graph / X card image every page shares (rendered at build time by vite/socialImage.ts and
 * served as a static file). The query string changes whenever the image does.
 */
export const SOCIAL_IMAGE: MetadataImage = {
  url: `/opengraph-image.png${
    import.meta.env.PUBLIC_SOCIAL_IMAGE_VERSION
      ? `?${import.meta.env.PUBLIC_SOCIAL_IMAGE_VERSION}`
      : ""
  }`,
  type: "image/png",
  width: 1200,
  height: 630,
  alt: SOCIAL_IMAGE_ALT,
};

export const ROOT_METADATA: Metadata = {
  metadataBase: SITE_URL,
  title: {
    default: TITLE,
    template: `%s | ${TITLE}`,
  },
  description: SITE_DESCRIPTION,
  applicationName: TITLE,
  // The icon, manifest and robots.txt are static files in public/, served straight from Workers
  // Assets without running the Worker.
  icons: { icon: { url: "/icon.svg", type: "image/svg+xml", sizes: "any" } },
  manifest: "/manifest.webmanifest",
  keywords: [
    "content moderation API",
    "AI content moderation",
    "image moderation API",
    "text moderation API",
    "content safety API",
    "NSFW detection API",
    "media CDN",
    "image CDN",
    "secure asset delivery",
  ],
  authors: [{ name: TITLE, url: SITE_URL }],
  creator: TITLE,
  publisher: TITLE,
  category: "technology",
  referrer: "origin-when-cross-origin",
  openGraph: {
    type: "website",
    locale: "en_US",
    siteName: TITLE,
    title: `${LANDING_TITLE} | ${TITLE}`,
    description: SITE_DESCRIPTION,
    images: [SOCIAL_IMAGE],
  },
  twitter: {
    card: "summary_large_image",
    title: `${LANDING_TITLE} | ${TITLE}`,
    description: SITE_DESCRIPTION,
    images: [SOCIAL_IMAGE],
  },
  robots: {
    index: true,
    follow: true,
    googleBot: {
      index: true,
      follow: true,
      "max-image-preview": "large",
      "max-snippet": -1,
      "max-video-preview": -1,
    },
  },
};

export const LANDING_METADATA: Metadata = {
  title: {
    absolute: `${LANDING_TITLE} | ${TITLE}`,
  },
  description: SITE_DESCRIPTION,
  alternates: {
    canonical: "/",
  },
  openGraph: {
    type: "website",
    locale: "en_US",
    url: "/",
    siteName: TITLE,
    title: `${LANDING_TITLE} | ${TITLE}`,
    description: SITE_DESCRIPTION,
  },
  twitter: {
    card: "summary_large_image",
    title: `${LANDING_TITLE} | ${TITLE}`,
    description: SITE_DESCRIPTION,
  },
};
